export default {
  itens: [],
  tipos: [
    { id: "APR", label: "APROVAR", title: "" },
    { id: "TOD", label: "TODOS", title: "TODOS" },
    { id: "APD", label: "APROVADOS", title: "APROVADOS" },
    { id: "REP", label: "REPROVADOS", title: "REPROVADOS" }
  ],
  tipo: { id: "APR", label: "APROVAR", title: "" }
};
